import React from 'react';
import Sidebar from '../components/Sidebar';
import ContentHeader from '../components/ContentHeader';
import { useAuth } from "../contexts/AuthContext";

const SettingsPage = () => {

  const {user} = useAuth();

  return (
    <div className="columns" style={{ height: '100vh', display: 'flex', flexDirection: 'row' }}>
      <Sidebar />
      <div className="column p-6 has-background-light">
        <ContentHeader title="Settings" subtitle="Change your settings" />
        <div className="columns mt-5" style={{ overflow: 'scroll' }}>
          <div className="column">
            {/* Profile Information Form */}
            <div className="box">
              <div className="is-flex is-align-items-center mb-3" style={{ borderBottom: '1px solid #dbdbdb', paddingBottom: '0.5em' }}>
                <span className="icon is-medium mr-2">
                  <i className="fas fa-user fa-lg"></i>
                </span>
                <h2 className="title is-5 has-text-weight-semibold">Profile Information</h2>
              </div>
              <div className="field">
                <label className="label">Profile Photo (Avatar)</label>
                <div className="control">
                  <div className="is-flex is-align-items-center">
                    <figure className="image is-64x64 is-rounded mr-3">
                      <img className="is-rounded" src="https://placehold.co/256" alt="Current Avatar" />
                    </figure>
                    <div className="file has-name">
                      <label className="file-label">
                        <input className="file-input" type="file" name="avatar" />
                        <span className="file-cta">
                          <span className="file-icon">
                            <i className="fas fa-upload"></i>
                          </span>
                          <span className="file-label">
                            Choose a file…
                          </span>
                        </span>
                        <span className="file-name">
                          No file uploaded
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field">
                <label className="label">Fullname</label>
                <div className="control">
                  <input className="input" type="text" placeholder="e.g. John Doe" />
                </div>
              </div>
              <div className="field">
                <label className="label">Email</label>
                <div className="control">
                  <input className="input" type="email" value={user.email} />
                </div>
              </div>
              <div className="field">
                <label className="label">Company</label>
                <div className="control">
                  <input className="input" type="text" placeholder="e.g. Acme Corp" />
                </div>
              </div>
              <div className="field">
                <label className="label">Role</label>
                <div className="control">
                  <input className="input" type="text" placeholder="e.g. Software Engineer" />
                </div>
              </div>
              <div className="field">
                <div className="control">
                  <button className="button is-primary">Save Changes</button>
                </div>
              </div>
            </div>

            {/* Danger Zone Section */}
            <div className="box">
              <div className="is-flex is-align-items-center mb-3" style={{ borderBottom: '1px solid #dbdbdb', paddingBottom: '0.5em' }}>
                <span className="icon is-medium mr-2 has-text-danger">
                  <i className="fas fa-exclamation-triangle fa-lg"></i>
                </span>
                <h2 className="title is-5 has-text-weight-semibold has-text-danger">Danger Zone</h2>
              </div>
              <div className="field">
                <p>Once you delete your account, there is no going back. Please be certain.</p>
              </div>
              <div className="field">
                <div className="control">
                  <button className="button is-danger">Delete Account</button>
                </div>
              </div>
            </div>
          </div>
          <div className="column">
            {/* Security Form */}
            <div className="box">
              <div className="is-flex is-align-items-center mb-3" style={{ borderBottom: '1px solid #dbdbdb', paddingBottom: '0.5em' }}>
                <span className="icon mr-2">
                  <i className="fas fa-shield-halved fa-lg"></i>
                </span>
                <h2 className="title is-5 has-text-weight-semibold">Security</h2>
              </div>
              <div className="field">
                <label className="label">Current Password</label>
                <div className="control">
                  <input className="input" type="password" />
                </div>
              </div>
              <div className="field">
                <label className="label">New Password</label>
                <div className="control">
                  <input className="input" type="password" />
                </div>
              </div>
              <div className="field">
                <label className="label">Confirm New Password</label>
                <div className="control">
                  <input className="input" type="password" />
                </div>
              </div>
              <div className="field">
                <div className="control">
                  <button className="button is-primary">Change Password</button>
                </div>
              </div>
            </div>
            {/* Preferences Form */}
            <div className="box">
              <div className="is-flex is-align-items-center mb-3" style={{ borderBottom: '1px solid #dbdbdb', paddingBottom: '0.5em' }}>
                <span className="icon is-medium mr-2">
                  <i className="fas fa-sliders-h fa-lg"></i>
                </span>
                <h2 className="title is-5 has-text-weight-semibold">Preferences</h2>
              </div>
              <div className="field">
                <label className="checkbox">
                  <input type="checkbox" />
                  Email Notifications
                </label>
              </div>
              <div className="field">
                <label className="checkbox">
                  <input type="checkbox" />
                  Dark Mode
                </label>
              </div>
              <div className="field">
                <label className="checkbox">
                  <input type="checkbox" />
                  Auto Save Code
                </label>
              </div>
              <div className="field">
                <div className="control">
                  <button className="button is-primary">Save Preferences</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
